<template>
  <div class="rightaside_content">
    <h3 class="headerTitle clearfix">
      <span>退款退货</span>
      <el-input class="search" size="small" v-model="orderNo" placeholder="输入订单编号搜索">
        <template slot="append">
          <el-button type="primary" class="el-icon-search" @click="search"></el-button>
        </template>
      </el-input>
    </h3>
    <div class="refund-order-list" v-loading="loading">
      <table class="refund-order">
        <tr>
          <th class="info">商品</th>
          <th>退款金额</th>
          <th>申请时间</th>
          <th>服务类型</th>
          <th>售后状态</th>
          <th>操作</th>
        </tr>
        <template v-for="order in refundOrderList">
        <tr :key="order.asOid"><td colspan="6"></td></tr>
        <tr class="refund-order-header">
          <td colspan="6">
            <span class="mr-10">订单编号：{{ order.orderNumber }}</span>
            <span class="mr-10">退款编号：{{ order.asOid }}</span>
            <span>商家：{{ order.merchantName }}</span>
            <span class="chat-icon" @click="contactSeller(order)"><i class="el-icon-chat-dot-round"></i></span>
            <span class="link" v-if="order.enableAppeal" @click="openAppeal(order)"><i class="el-icon-headset"></i>申请平台介入</span>
          </td>
        </tr>
        <tr class="refund-order-content">
          <td>
            <div class="good clearfix" v-for="good in order.goodList" :key="good.bxysid">
              <el-image class="good-cover fl" :src="good.goodImg"></el-image>
              <div  @click="$tools.showGoodInBlank(good.commodityId)"
                    class="good-title u-line-two">{{ good.goodsName }}</div>
              <div class="good-sku">{{ good.bxysName || '默认规格' }}</div>
            </div>
          </td>
          <td>
            <div>自付金额：￥{{ order.afterCashAmount | decimal }}</div>
            <div>储值金额：￥{{ order.afterYhmoneyAmount | decimal }}</div>
            <div>代金券金额：￥{{ order.afterVoucherAmount | decimal }}</div>
            <div v-if="order.refundDeliveryCashAmount">自付运费金额：￥{{ order.refundDeliveryCashAmount | decimal }}</div>
            <div v-if="order.refundDeliveryYhAmount">储值运费金额：￥{{ order.refundDeliveryYhAmount | decimal }}</div>
          </td>
          <td>{{ order.createTime }}</td>
          <td class="amount">{{ order.returnType === 1 ? '退货退款' : '退款' }}</td>
          <td class="state" :class="{
            'red': order.status === 17,
            'grey': order.status === 18,
          }">
            <div>{{ stateMaps[order.status] }}</div>
            <div v-if="order.regHandlerStatus !== 'NONE'">{{platformState[order.regHandlerStatus]}}</div>
          </td>
          <td>
            <div><el-link type="warning" @click="showRefundDetail(order)">服务详情</el-link></div>
            <div><el-link type="info" @click="cancelRefundOrder(order)" v-if="order.status <= 15">取消退款</el-link></div>
          </td>
        </tr>
        </template>
      </table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="{ total, pageSize, currentPage: pageNum }" @callFather="handlePageChange"></Pagination>
    <refund-appeal ref="appeal"></refund-appeal>
    <!--  退款详情  -->
    <refund-detail ref="detail" @cancel="cancelRefundOrder"></refund-detail>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination';
import RefundDetail from './refundDetail';
import RefundAppeal from './refundAppeal';
import {backMoneyList, remove_after_sale} from '../../../api/xunyou'

export default {

  data() {
    return {
      loading: false,
      refundOrderList: [],
      orderNo: null,
      pageNum: 1,
      pageSize: 10,
      total: 10,
      stateMaps: {
        11: '提交退单',
        12: '退单审核',
        13: '收货确认',
        14: '退款确认',
        15: '收款确认',
        16: '完成',
        17: '商家拒绝退款',
        18: '已取消'
      },
      platformState: {
        'NONE': '无平台介入',
        'APPLY': '平台介入中',
        'REFUND': '平台退款',
        'REJECT': '平台驳回'
      }
    };
  },
  components: {
    Pagination,
    RefundDetail,
    RefundAppeal
  },
  created() {
    if (this.$route.query.orderNo) {
      this.orderNo = this.$route.query.orderNo;
    }
    this.getRefundOrderList();
  },
  methods: {
    openAppeal (order) {
      this.$refs.appeal.show(order);
    },
    // 联系卖家
    contactSeller (order) {
      this.$tools.contactService(order.bxmId, 'MER');
    },
    cancelRefundOrder (order) {
      this.$confirm('确定取消此退款订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        remove_after_sale({ ids: order.bXyOasid }).then(res => {
          console.log('取消售后结果：', res);
          if (res.code === 0) {
            this.getRefundOrderList();
          } else {
            this.$message.error(res.msg);
          }
        }).catch(err => {
          console.error('错误：', err);
        });
      });
    },
    showRefundDetail (order) {
      this.$refs.detail.showDialog(order);
    },
    search() {
      this.pageNum = 1;
      this.getRefundOrderList();
    },
    handlePageChange () {
      this.pageSize = val.pageSize;
      this.pageNum = val.currentPage;
      this.getRefundOrderList();
    },
    getRefundOrderList () {
      let params = {
        uid: this.$store.getters.userId,
        orderNumber: this.orderNo || '',
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.loading = true;
      backMoneyList(params).then(res => {
        console.log('售后列表：', res);
        this.loading = false;
        if (res.code === 0) {
          this.refundOrderList = res.rows.map(ele => {
            ele['enableAppeal'] = this.isEnableAppeal(ele);
            return ele;
          });
          this.total = res.total;
        }
      }).catch(err => {
        this.loading = false;
        console.log('错误：', err);
      });
    },
    isEnableAppeal (refundData) {
      let isTimeEnable = false;
      if (refundData && refundData.returnTime) {
        const threeDays = 3 * 24 * 60 * 60 * 1000;
        const lastTime = new Date(refundData.returnTime).getTime() + threeDays;
        const nowTime = new Date().getTime();
        isTimeEnable =  nowTime <= lastTime;
      }
      return refundData.status === 17 && refundData.regHandlerStatus === 'NONE' && isTimeEnable;
    }
  }
};
</script>

<style scoped lang="less">
.headerTitle {
  font-size: 20px;
  color: #666;
  .search{
    float: right;
    width: 320px;
  }
}

.mr-10{
  margin-right: 10px;
}
.red{
  color: var(--main-theme-color) !important;
}
.grey{
  color: #888888 !important;
}
.refund-order{
  margin-top: 10px;
  width: 100%;
  .refund-order-header{
    padding: 0 20px;
    background: #EAF8FF;
    font-size: 12px;
    border: 1px solid #91CFFF;
    color: #3c3c3c;
    .chat-icon{
      padding: 0 5px;
      cursor: pointer;
      font-size: 14px;
      &:hover{
        color: var(--main-theme-color);
      }
    }
    .link{
      float: right;
      margin-top: 2px;
      color: var(--main-theme-color);
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
  }
  .refund-order-content{
    border: 1px solid #eeeeee;
  }
  th{
    background-color: #e9e9e9;
    padding: 10px;
    text-align: left;
  }
  td{
    padding: 10px;
  }
  .info{
    width: 350px;
  }
  .good-cover{
    width: 70px;
    height: 70px;
    border: 1px solid #F5F5F5;
    border-radius: 3px;
    margin-right: 10px;
  }
  .good-title{
    font-size: 14px;
    line-height: 1.3;
    margin-bottom: 10px;
    cursor: pointer;
    &:hover{
      color: var(--main-theme-color);
      text-decoration: underline;
    }
  }
  .amount{
    color: var(--main-theme-color);
  }
  .state{
    color: #0c80dc;
  }
}
</style>







// WEBPACK FOOTER //
// src/views/myOrder/customerService/refund.vue